import { Color } from "three";
import { BasePanel } from "./BasePanel";
import VUtil from "../VUILib/VUtils.js";

const bg = "/assets/vrUI/common/bg.png";
const titleBgPath = "/assets/vrUI/common/titleBg.png";
const closeIconPath = "/assets/vrUI/common/close.png";
const sliderBgPath = "/assets/vrUI/skyPanel/sliderBg1.png";
const sliderHandlePath = "/assets/vrUI/skyPanel/sliderHandle.png";
const btnBgPath = "/assets/vrUI/common/btnBg.png";
const sunIconPath = "/assets/vrUI/skyPanel/sun.png";
const fogIconPath = "/assets/vrUI/skyPanel/fog.png";
const rainIconPath = "/assets/vrUI/skyPanel/rain.png";
const snowIconPath = "/assets/vrUI/skyPanel/snow.png";

export class SkyPanel extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  async init() {
    const width = 1;
    const height = 1.2;

    // container
    const bgMap = await this.manager.loadManager.loadTexture(bg);
    const container = this.uilib.createContainer({
      color: 0x0b0c0c,
      opacity: 0.9,
      map: bgMap,
      width: width,
      height: height,
      radius: 0.025,
      dragable: true,
    });
    this.uilib.addUIToScene(container);
    container.visible = this._visible;
    //container.scale.set(0.5, 0.5, 0.5);

    this.uiElements.push(container);
    container.position.x -= 0.5;
    // title
    const title = this.uilib.createText({
      text: "天空",
      textColor: 0xafbbe3,
      textSize: 0.05,
      font: "bold",
      align: "left",
    });
    container.add(title);
    title.position.y = height / 2 - 0.08;
    title.position.x = -width / 2 + 0.08;

    // close btn
    const closeIcon = await this.manager.loadManager.loadTexture(closeIconPath);
    const closeBtn = this.uilib.createBtn({
      map: closeIcon,
      text: "",
      color: "#A8B4DB",
      width: 0.1,
      height: 0.1,
      radius: 0,
    });
    closeBtn.addHoverEnterEvent((obj) => {
      obj.material.color = new Color("#6275B5");
    });
    closeBtn.addHoverExitEvent((obj) => {
      obj.material.color = new Color("#A8B4DB");
    });
    closeBtn.addClickEvent((obj) => {
      this.closePanel();
    });
    container.add(closeBtn);
    closeBtn.position.z = 0.001;
    closeBtn.position.y = height / 2 - 0.08;
    closeBtn.position.x = width / 2 - 0.11;

    // titleBg
    this.manager.loadManager.loadTexture(titleBgPath, (tex) => {
      const titleBg = this.uilib.createImage({
        map: tex,
        width: width * 0.9,
        height: 0.1,
        radius: 0,
      });
      container.add(titleBg);
      titleBg.position.y = height / 2 - 0.1;
    });

    const sliderBg = await this.manager.loadManager.loadTexture(sliderBgPath);
    const sliderHandle = await this.manager.loadManager.loadTexture(
      sliderHandlePath
    );
    const btnBg = await this.manager.loadManager.loadTexture(btnBgPath);

    // 太阳角度
    {
      const text1 = this.uilib.createText({
        text: "太阳角度",
        textColor: 0xafbbe3, //0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      container.add(text1);
      text1.position.x = -width / 2 + 0.08;
      text1.position.y = 0.38;
      const slider1 = this.uilib.createSlider({
        map: sliderBg,
        color: 0xffffff,
        handleMap: sliderHandle,
        handleColor: 0xffffff,
        fillOpacity: 0,
        width: width * 0.75,
        height: 0.03,
        radius: 0.015,
      });
      slider1.setProgressValue(this.manager.interface.getSunAngle());
      slider1.addOnValueChangeEvent((v) => {
        this.manager.interface.setSunAngle(v);
      });
      container.add(slider1);
      slider1.position.y = 0.3;
    }

    // 晴雾雨雪 按钮
    const btns = [
      {
        text: "晴",
        icon: sunIconPath,
      },
      {
        text: "雾",
        icon: fogIconPath,
      },
      {
        text: "雨",
        icon: rainIconPath,
      },
      {
        text: "雪",
        icon: snowIconPath,
      },
    ];
    for (var i = 0; i < btns.length; i++) {
      const icon = await this.manager.loadManager.loadTexture(btns[i].icon);
      const btn = this.uilib.createBtn({
        map: btnBg,
        text: "",
        width: 0.15,
        height: 0.07,
        radius: 0,
      });
      btn.addClickEvent((obj) => {
        this.onClickBtn(obj);
      });
      container.add(btn);
      // icon
      const image = this.uilib.createImage({
        renderOrder: 100000,
        map: icon,
        width: 0.05,
        height: 0.05,
        radius: 0,
      });
      btn.add(image);
      image.position.x = -0.025;
      // text
      const text = this.uilib.createText({
        text: btns[i].text,
        textColor: 0x94a3bc,
        font: "bold",
        textSize: 0.03,
      });
      btn.add(text);
      text.position.x = 0.025;

      btn.position.x = -width / 2 + 0.2 + i * 0.2;
      btn.position.y = 0.2;
      btn.position.z = 0.001;
      btn.name = "btn_" + btns[i].text;
    }

    // line
    const line = this.uilib.createImage({
      map: sliderBg,
      width: width * 0.9,
      height: 0.001,
      radius: 0,
    });
    container.add(line);
    line.position.y = 0.1;

    // 环境光强度
    {
      const text1 = this.uilib.createText({
        text: "环境光强度",
        textColor: 0xafbbe3, //0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      container.add(text1);
      text1.position.x = -width / 2 + 0.08;
      text1.position.y = 0.0;
      const slider1 = this.uilib.createSlider({
        map: sliderBg,
        color: 0xffffff,
        handleMap: sliderHandle,
        handleColor: 0xffffff,
        fillOpacity: 0,
        width: width * 0.75,
        height: 0.03,
        radius: 0.015,
      });
      container.add(slider1);
      slider1.position.y = -0.08;
      slider1.setProgressValue(this.manager.interface.getAmbientIntensity());
      slider1.addOnValueChangeEvent((v) => {
        this.manager.interface.setAmbientIntensity(v);
      });
    }

    // 雾强度
    {
      const text1 = this.uilib.createText({
        text: "雾强度",
        textColor: 0xafbbe3, //0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      container.add(text1);
      text1.position.x = -width / 2 + 0.08;
      text1.position.y = -0.18;
      const slider1 = this.uilib.createSlider({
        map: sliderBg,
        color: 0xffffff,
        handleMap: sliderHandle,
        handleColor: 0xffffff,
        fillOpacity: 0,
        width: width * 0.75,
        height: 0.03,
        radius: 0.015,
      });
      container.add(slider1);
      slider1.position.y = -0.26;
      slider1.setProgressValue(this.manager.interface.getFogDensity());
      slider1.addOnValueChangeEvent((v) => {
        this.manager.interface.setFogDensity(v);
      });
    }

    // 环境光颜色
    {
      const text1 = this.uilib.createText({
        text: "环境光颜色",
        textColor: 0xafbbe3, //0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      container.add(text1);
      text1.position.x = -width / 2 + 0.08;
      text1.position.y = -0.37;

      const ambientLightColor = this.manager.interface.getAmbientColor();

      const colorPicker = this.uilib.createColorPicker({
        width: 0.5,
        height: 0.5,
        radius: 0,
        iconWidth: 0.075,
        iconHeight: 0.075,
        needColorText: true,
        defaultColor: ambientLightColor,
        textColor: 0xafbbe3, //0xafbbe3,
      });
      colorPicker.addOnValueChangeEvent((color) => {
        this.manager.interface.setAmbientColor(color);
      });
      container.add(colorPicker);
      colorPicker.position.y = -0.37;
      colorPicker.position.x = 0;
      colorPicker.position.z = 0.002;
    }

    // 雾颜色
    {
      const text1 = this.uilib.createText({
        text: "雾颜色",
        textColor: 0xafbbe3, //0xafbbe3,
        textSize: 0.045,
        font: "bold",
        align: "left",
      });
      container.add(text1);
      text1.position.x = -width / 2 + 0.08;
      text1.position.y = -0.47;

      const fogColor = this.manager.interface.getFogColor();

      const colorPicker = this.uilib.createColorPicker({
        width: 0.5,
        height: 0.5,
        radius: 0,
        iconWidth: 0.075,
        iconHeight: 0.075,
        needColorText: true,
        defaultColor: fogColor,
        textColor: 0xafbbe3, //0xafbbe3,
      });
      colorPicker.addOnValueChangeEvent((color) => {
        this.manager.interface.setFogColor(color);
      });
      container.add(colorPicker);
      colorPicker.position.y = -0.47;
      colorPicker.position.x = 0;
      colorPicker.position.z = 0.002;
    }

    if (!this._visible) {
      this.hide();
    }
  }

  onClickBtn(obj) {
    const tagName = obj.name.split("_")[1];
    switch (tagName) {
      case "晴":
        break;
      case "雾":
        break;
      case "雨":
        break;
      case "雪":
        break;
      default:
        break;
    }
  }

  closePanel() {
    super.closePanel();
  }
}
